import { render } from "./LegalText.vue?vue&type=template&id=5e9cede2"
import script from "./LegalText.vue?vue&type=script&lang=js"
export * from "./LegalText.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__